import React from 'react';
import ServiceCard from '../ServiceCard/ServiceCard';
import services from "../../Data/servicesData";
import "./NavigateServices.css";

const NavigateServices = () => {
  return (
    <section className="services section section-muted" aria-labelledby="services-heading">
      <div className="section-inner">
        <div className="section-header">
          <h2 id="services-heading" className="section-title">Hizmetlerimiz</h2>
          <p className="section-subtitle">
            Kombi, klima, petek temizliği ve beyaz eşya tamirinde Bursa genelinde
            profesyonel teknik servis. Hemen arayın, aynı gün çözüm alın.
          </p>
        </div>

        <div className="services-grid-modern">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              image={service.image}
              title={service.title}
              desc={service.desc}
              to={service.to}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default NavigateServices;
